(function() {
  'use strict';
  
  // Esperar a que el DOM esté listo
  function init() {
    const btnUp = document.getElementById('btnUp');
    const btnBack = document.getElementById('btnBack');
    
    if (!btnUp || !btnBack) return;
    
    let isAtBottom = false;
    let scrollTimeout = null;
    
    function checkScrollPosition() {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollPercent = (scrollTop + windowHeight) / documentHeight;
      
      const shouldShow = scrollPercent >= 0.8;
      
      if (shouldShow && !isAtBottom) {
        isAtBottom = true;
        btnUp.classList.add('visible');
      } else if (!shouldShow && isAtBottom) {
        isAtBottom = false;
        btnUp.classList.remove('visible');
      }
    }
    
    function debounceScroll() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(checkScrollPosition, 10);
    }
    
    function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    
    function goBack() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    }
    
    // Event listeners
    window.addEventListener('scroll', debounceScroll, { passive: true });
    window.addEventListener('resize', debounceScroll, { passive: true });
    
    btnUp.addEventListener('click', scrollToTop);
    btnBack.addEventListener('click', goBack);
    
    // Inicializar
    setTimeout(checkScrollPosition, 100);
  }
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();